module.exports = __webpack_public_path__ + "static/ses-2021-our-performance-499c5c22adf97d5c0da0dd3749ac9d58.pdf";